import {
  UPDATE_PROMO_CODE,
  SET_SEARCH_DATA,
  PROMO_CODE_VALIDATION,
  GET_ROOM_RESULTS_FAIL
} from "../constants/actionTypes";
import initialstate from "./initialState";

export const promoCodeReducer = (state = initialstate.promoCode, action) => {
  switch (action.type) {
    case UPDATE_PROMO_CODE:
      return action.payload;

    case SET_SEARCH_DATA:
      return (
        (action.payload && action.payload.promoCode) || initialstate.promoCode
      );

    default:
      return state;
  }
};

export const isPromoCodeValidReducer = (
  state = initialstate.isPromoCodeValid,
  action
) => {
  switch (action.type) {
    case PROMO_CODE_VALIDATION:
      return action.payload;

    case GET_ROOM_RESULTS_FAIL:
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/promoCodeReducer.js